import { createRoute, redirect } from '@tanstack/react-router';

import { rootRoute } from '../root';

export const IndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({
      to: '/installations',
    });
  },
});
